import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  chosenLanguageChanged = new Subject<string>();
  phoneNumberChanged = new Subject<string>();
  scannerSizeMultiplierChanged = new Subject<number>();
  callButtonClicked = new Subject<void>();
  settingsButtonClicked = new Subject<void>();
  refreshButtonClicked = new Subject<void>();
  messagesChanged = new Subject<void>();
  tourChanged = new Subject<void>();
  isLoading = new Subject<boolean>();

  constructor() {
  }
}
